// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__pebWh","button":"notFound_button__MDCzx"};